module.exports = __webpack_public_path__ + "static/media/tuTrend.58f7eb97.png";